import React from 'react';
import styled from 'styled-components';
import LoadingBar from 'react-redux-loading-bar';

const Wrapper = styled.div`
  width: 100vw;
  position: fixed;
  top: 0px;
  left: 0px;
  & > div > div {
    background-color: ${props => props.theme.primary} !important;
  }
`;

export default () => (
  <Wrapper>
    <LoadingBar />
  </Wrapper>
);
